import React from "react";
import { useParams } from "react-router-dom";
import VSheet from "../../component/VSheet";

export interface ApplicationProps {
  workflowTemplateId: string;
}

export default function ProjectDetail() {
  const params = useParams<ApplicationProps>();
  return (
    <>
      <VSheet workflowTemplateId={params.workflowTemplateId} dataId="0" />
    </>
  );
}
